import { GzQueryInputWebComponent } from './component/GzQueryInputWebComponent';
import { WEB_COMPONENT_SEARCH_QUERY } from '../../webcomponents.constants';

export { GzQueryInputWebComponent };

window.customElements.define(WEB_COMPONENT_SEARCH_QUERY, GzQueryInputWebComponent);
